<template>
  <div class="page" v-cloak>
    <p class="top-zhuce"><span @click="editPhone">注册</span></p>

    <h3>快速登陆您的账号</h3>
    <!-- <p class="top-tips">直接获取手机验证码即可</p> -->

    <div class="centers">
      <!-- 手机号 -->
      <div class="input-tips">
        账号
        <van-icon class="input-success" v-if="isPhone" name="checked" />
      </div>
      <div class="code-input">
        <input type="Number" v-model="phone" placeholder="请输入您的手机号"/> 
      </div> 

      <!-- 密码 -->
      <div class="input-tips"> 密码</div>
      <div class="code-input">
        <input type="password" v-model="password"  placeholder="请输入您的密码"/>
      </div>
    </div>

    <!-- 按钮 -->
    <div class="foot-btn" @click="login">确定登陆</div>
    <p class="reset-pwd"><span  @click="next">下次登陆</span> | <span  class="left-t" @click="resetPwd">忘记密码</span></p>

  </div>
</template> 

<script>
import { getToken, setToken, removeToken } from "@/utils/auth"; 

export default {
  name: "Login",
  components: { 
  },
  props: {},
  data() {
    return {
      checked: false,
      time: 0,
      currentTime: 60,
      phone: "",
      isPhone: false,
      password: "", 
    };
  },
  watch: {
    phone(newValue, oldValue) {
      if (!/^1[3456789]\d{9}$/.test(newValue)) {
        this.isPhone = false;
      } else {
        this.isPhone = true;
      }
    }, 
  },
  created() {},
  mounted() {},
  methods: { 
    login() {
      var that = this;
      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        this.$toast.fail("请填写正确的手机号！");
        return;
      }
      if (!that.password) {
        this.$toast.fail("密码不可为空，请重新填写！");
        return;
      }
      // if (!that.checked) {
      //   this.$toast.fail("请选择已阅读并同意服务条款！");
      //   return;
      // }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let data = {
        phone: that.phone,
        password: that.password,
        openid: Lockr.get("openId"), //微信openid
      };
      this.$post("/api/login", data, data).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 0) {
          this.$toast.clear(); //关闭弹窗

          // Lockr.set("mobile", that.phone); // 手机号
          // this.$store.commit("set_Mobile", that.phone);

          // company_id: 0
          // head_photo: "http://weizhui.xzbfb.com/static/avatar.jpg"
          // invite_code: "XQJD8V"
          // open_id: "oo05wvzjtnTRFecFjBLPY_ZMI5_M"
          // phone_no: "18839135695"
          // sex: 1
          // user_id: "0292d76fad2365c7d24d3926b6674823"
          // user_nickname: "BFBNyJZG"

          that.$toast({ message: "登陆成功~" });

          Lockr.set("userId", res.data.data.user_id); // uid 
          that.$store.commit("set_user_id", res.data.data.user_id);

          Lockr.set("referral_code", res.data.data.invite_code);// 邀请码
          that.$store.commit("set_referral_code", res.data.data.invite_code);// 邀请码

          Lockr.set("userInfo", res.data.data); //用户信息

          Lockr.set("mobile", res.data.data.phone_no); // 手机号
          that.$store.commit("set_Mobile", res.data.data.phone_no); 


          console.log(Lockr.get("oldUrl"));
          let beforeLoginUrl = Lockr.get("oldUrl");
          if (beforeLoginUrl && beforeLoginUrl.name != "login") {
            that.$router.replace({
              name: beforeLoginUrl.name,
              query: beforeLoginUrl.query,
              params: beforeLoginUrl.params,
            });
            // this.$router.push({name: beforeLoginUrl.name, query: beforeLoginUrl.query, params: beforeLoginUrl.params});
          } else {
            that.$router.go(-1);
            // that.getUserInfo(-1);
            // this.$router.push({name:'index', query:{}, params:{}});
          }
        } else if(res.data.code == -404){
          window.location.href = 'http://xzlm.bijingauto.cn/bfb_check_user?phone='+that.phone

        }else{
          that.$toast.fail(res.data.message);
        }
      });
    },
    goIndex() {
      Lockr.set("oldUrl", {});
      this.$router.push({
        name: "index",
        query: {
          id: "",
        },
      });
    },
 
    // 注册
    editPhone() {
      this.$router.replace({ name: "new-bind", query: {} });
    },
    // 忘记密码
    resetPwd() {
      this.$router.replace({ name: "reset-pwd", query: {} });
    },
    // 忘记密码
    next() {
      this.$router.replace({ name: "index", query: {} });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #fff;
  padding-top: 40px;

  .top-zhuce {
    text-align: right;
    padding: 0 10px;
    color: #ff5000;
    font-size: 16px;
  }

  h3 {
    text-align: left;
    margin-top: 50px;
    padding-left: 30px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 61px;
    color: #2a2e43;
  }
  .top-tips {
    text-align: left;
    padding-left: 38px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #999999;
  }
  .centers {
    margin-top: 50px;
    padding: 0 38px;
    .input-tips {
      margin-top: 10px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .input-success {
        display: inline-block;
        width: 18px;
        height: 18px;
        font-size: 18px;
        color: #ff5000;
      }
    }
    .code-input {
      // margin: 100px 0;
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: space-between;
      input {
        width: 70%;
        height: 100%;
        text-align: left;
        background: none;
        outline: none;
        border: none;
        font-size: 18px;
      }
      .code-btn {
        width: 80px;
        height: 25px;
        border: 1px solid #999999;
        opacity: 1;
        border-radius: 5px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 21px;
        color: #999999;
      }

      .arr_icon {
        border: 1px solid #ff5000;
        color: #ff5000;
      }
    }
  }
  .foot-tips {
    margin-top: 40px;
    text-align: left;
    padding-left: 38px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 21px;
    color: #999999;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-left: 5px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #1775e6;
    }
  }
  .foot-btn {
    width: 300px;
    height: 50px;
    background: #ff5000;
    opacity: 1;
    border-radius: 25px;
    margin: 20px auto;

    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 30px;
    color: #ffffff;
    letter-spacing: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .go-page {
    text-align: center;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 27px;
    color: #999999;
    letter-spacing: 2px;
    text-decoration: underline;
  }
}
.reset-pwd{
  text-align: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 27px;
    color: #999999;
    letter-spacing: 2px;
    text-decoration: underline;

    .left-t{
      color: #ff5000;
      
    }
}
</style>
